// Gatsby supports TypeScript natively!
import React from "react"
import { PageProps, Link } from "gatsby"
import projects from "../data/projects"
import EntryProject from "../components/projectentry"

import Layout from "../components/layout"
import SEO from "../components/seo"

function createProjects(service) {
  return (
    <EntryProject
      key={service.id}
      title={service.title}
      image={service.image}
      githuburl={service.githuburl}
      linkedinurl={service.linkedinurl}
    />
  );
}

const SecondPage = (props: PageProps) => (
  <Layout>
    <SEO title="Projects" />
    <div style={{backgroundColor:"#1F2235"}}>
    <div className="row" style={{color:"white",paddingTop:"5%"}}>
      <div className="services">
        <h2 className="align-middle" style={{color:"#fff"}}><b>Project Showcase</b></h2>
        <p className="align-middle" style={{color:"#dfdfdf"}}>Here are some of the Web Development & Wordpress Projects that I had made.</p>
        <div className="row myservices-container">
          {projects.map(createProjects)}
        </div>
      </div>
    </div>
    </div>
  </Layout>
)

export default SecondPage
